import React, { useEffect, useState } from "react";
import ShopSalary from "./shopsalary/shopsalary";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CleanerSalaryMain from "./cleanersalary/cleanersalarymain";

const SalaryMain: React.FC<any> = (props) => {

    const [select, setSelect] = useState("shopsalary");

    useEffect(() => {
        props.activateMenuList("salary");

    }, []);

    const notify = (kind: string, value: string) => {
        switch (kind) {
            case "success":
                toast.success(value, {
                    position: "bottom-right",
                    autoClose: 2500,
                    hideProgressBar: true,
                    theme: "colored"
                });
                break;
            case "error":
                toast.error(value, {
                    position: "bottom-right",
                    autoClose: 2500,
                    hideProgressBar: true,
                    theme: "dark"
                });
                break;
            default:
                break;
        }
    }

    return (
        <div className="main2" style={{
            overflowY: "auto",
        }}>
            <div>
                <div className="title"><img className="editImage" src="img/off/salary.svg" style={{
                    width: "30px",
                }} />급여 관리</div>
            </div>
            <div className="menu">
                <div className="submenu">
                    <div className={`menu_status ${select === "shopsalary" ? "active" : ""}`} onClick={(e) => { setSelect("shopsalary") }}>
                        매장 직원 급여
                    </div>
                    <div className={`menu_status ${select === "cleanersalary" ? "active" : ""}`} onClick={(e) => { setSelect("cleanersalary") }}>
                        청소 직원 급여
                    </div>
                </div>
            </div>
            <div>
                {
                    select === "shopsalary"
                        ?
                        <ShopSalary user={props.user}
                            notify={notify}
                        />
                        :
                        ""
                }
                {
                    select === "cleanersalary"
                        ?
                        <CleanerSalaryMain user={props.user}
                            notify={notify}
                        />
                        :
                        ""
                }

            </div>
        </div>
    )
}

export default SalaryMain;